<script setup lang="ts">
import { MovesQuality, type Move } from '@/types'
import ActionLabel from './ActionLabel.vue'
import { actionIcons } from '@/constants'

const { items } = defineProps<{ items: Move[] }>()
</script>

<template>
  <div
    class="flex flex-col justify-center items-center bg-dark-grey w-full rounded-lg desktop:rounded-[8px] p-3.5 desktop:p-[16px] mb-3.5"
  >
    <div class="text-white text-base font-semibold mb-4 w-full">Action Analysis</div>
    <ActionLabel
      v-for="item in items"
      :key="item.quality"
      :label="MovesQuality[item.quality]"
      :icon="actionIcons[item.quality]"
      :count="item.count"
    />
  </div>
</template>
